import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-learn-more', {
    fontStyle: 'normal',
});

cssRule('a', {
    color: applyColor(DesignTokens.color.link.standalone.default.default, '#1a699e'),
    textDecoration: 'none',
    cursor: 'pointer',
    outline: 0,
});

cssRule('a:hover', {
    color: applyColor(DesignTokens.color.link.standalone.default.hover, '#2a79af'),
    textDecoration: 'underline',
});

cssRule('a:focus', {
    color: applyColor(DesignTokens.color.link.standalone.default.active, '#15557f'),
    textDecoration: 'underline',
});

cssRule('a.tb-disabled', {
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
    textDecoration: 'none',
    pointerEvents: 'none',
});

